import React from 'react';
import styled from 'styled-components';

const StyledTransactionsIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const TransactionsIcon: React.FC = () => (
  <StyledTransactionsIcon viewBox="0 0 24 24">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 12H5v-1h14v1zm-4-4H5v-1h10v1zm4-4H5V7h14v1z" />
  </StyledTransactionsIcon>
);

export default TransactionsIcon;